<template>
  <va-edit-layout>
    <clubs-form :id="id" :title="title" :item="item"></clubs-form>
  </va-edit-layout>
</template>

<script>
export default {
  props: ["id", "title", "item"],
};
</script>
